import React, { Fragment, useMemo } from 'react';
import panelClasses from './Panel.module.scss';
import { Tooltip } from '../../actions/Tooltip';
import { idGenerator } from '../../../helpers/idGenerator';
import classNames from 'classnames';

export type PanelHeaderProps = {
  title: string;
  titleBadge?: JSX.Element | null;
  subTitle?: string | JSX.Element;
  squareButtonMenu?: JSX.Element | null;
  tooltip?: string | JSX.Element;
  subTitleTooltip?: string;
  isChartPanel?: boolean;
  disabled?: boolean;
};

export const PanelHeader = (props: PanelHeaderProps): JSX.Element => {
  const id = useMemo(() => idGenerator('evergreenTooltip'), []);
  return (
    <Fragment>
      <div className={'grid-x align-justify margin-top-small-24 margin-bottom-small-20 '}>
        <div
          className={classNames('cell small-12', panelClasses.OffsetForSquareButton, {
            [panelClasses.OffsetForSquareButtonChartPanel]: props.isChartPanel
          })}>
          <div className={'grid-x'}>
            <div
              className={classNames('cell shrink', {
                [panelClasses.TitleContainerFeatureDisabled]: props.disabled
              })}>
              <h4>{props.title}</h4>
            </div>
            {props.titleBadge && <div className={'cell shrink'}>{props.titleBadge}</div>}
            {props.tooltip && (
              <div className={'cell shrink'}>
                <Tooltip pointer target={`#${id}`} type={'inlined'}>
                  {props.tooltip}
                </Tooltip>
              </div>
            )}
          </div>
          {props.subTitle && (
            <span
              className={classNames(panelClasses.SubHeading, {
                [panelClasses.SubHeadingChartPanel]: props.isChartPanel
              })}>
              <>
                {props.subTitle}
                {props.subTitleTooltip && (
                  <Tooltip pointer target={`#subTitleTooltip${id}`} type={'inlined'}>
                    <>{props.subTitleTooltip}</>
                  </Tooltip>
                )}
              </>
            </span>
          )}
        </div>
      </div>
      {props.squareButtonMenu && <div className={panelClasses.DotMenu}>{props.squareButtonMenu}</div>}
    </Fragment>
  );
};
